import React, { useMemo, useRef } from "react";
import AntdModal from "../../../common/AntdModal";
import { useDispatch, useSelector } from "react-redux";
import ActivityReportingTemplate from "../../../Finance/advanceAccountabilityForms/reportingTemplate/ActivityReportingTemplate";
import { useReportingTemplateStore } from "../../../../config/stores";
import RecordStatusButtons from "../../../common/FormStatusButtons";
import advanceAccountabilityFormThunks from "../../../../config/thunks/finance/advanceAccountabilityForm/advanceAccountabilityForm.thunks";
import AppButton from "../../../common/AppButton";
import { AiOutlinePrinter, AiOutlineReload } from "react-icons/ai";
import { Card, Space } from "antd";
import { useReactToPrint } from "react-to-print";
import PrintActivityReportingTemplate from "../../../Finance/advanceAccountabilityForms/reportingTemplate/PrintActivityReportingTemplate";

const ViewActivityReport = () => {
  const reportingTemplateStore = useReportingTemplateStore();
  const dispatch = useDispatch();
  const {
    advanceAccountabilityFormsDetails,
    advanceAccountabilityFormsDetailsLoading,
  } = useSelector((state) => state.advanceAccountabilityFormsState);
  const reportingTemplate = useMemo(() => {
    return advanceAccountabilityFormsDetails.reportingTemplate || {};
  }, [advanceAccountabilityFormsDetails.reportingTemplate]);

  const reloadPaymentVoucher = () => {
    dispatch(
      advanceAccountabilityFormThunks.getAdvanceAccountabilityFormDetails(
        advanceAccountabilityFormsDetails.id
      )
    );
  };

  const contentRef = useRef();

  const handlePrint = useReactToPrint({
    contentRef,
    documentTitle: "STAFF APPRAISAL",
  });

  const onPrint = () => {
    setTimeout(() => {
      handlePrint();
    }, [10]);
  };
  return (
    <div>
      <AntdModal
        customSize={1300}
        title="ACTIVITY REPORT"
        open={reportingTemplateStore.viewActivityReport}
        closeModal={() => {
          reportingTemplateStore.setViewActivityReport(false);
        }}
        footer={[
          <Space>
            <RecordStatusButtons
              requiresSubmitted
              submitText="Submit Activity Report"
              checkText="Review/Check Activity Report"
              approveText="Approve Activity Report"
              data={reportingTemplate}
              storeActions={{
                approve: async (id) => {
                  await reportingTemplateStore.approveReportingTemplate(id);
                  reloadPaymentVoucher();
                },
                approving: reportingTemplateStore.approvingReportingTemplate,
                submit: async (id) => {
                  await reportingTemplateStore.submitReportingTemplate(id);
                  reloadPaymentVoucher();
                },
                submitting: reportingTemplateStore.submittingReportingTemplate,
                check: async (id) => {
                  await reportingTemplateStore.checkReportingTemplate(id);
                  reloadPaymentVoucher();
                },
                checking: reportingTemplateStore.checkingTemplate,
                undoingApproval:
                  reportingTemplateStore.undoingReportTemplateApproval,
                undoApprove: async (id) => {
                  await reportingTemplateStore.undoApproval(id);
                  reloadPaymentVoucher();
                },
              }}
            />

            <AppButton
              iconBefore={<AiOutlineReload />}
              key="reload"
              type="dashed"
              onClick={reloadPaymentVoucher}
              text="Reload Activity Report"
            />
            <AppButton
              iconBefore={<AiOutlinePrinter />}
              text="Print Activity Report"
              type="dashed"
              onClick={onPrint}
            />
          </Space>,
        ]}
      >
        {reportingTemplate && (
          <Card loading={advanceAccountabilityFormsDetailsLoading}>
            <ActivityReportingTemplate showSubmitButton={false} />
            <div className="d-none">
              <div className="p-2 border m-2" ref={contentRef}>
                <PrintActivityReportingTemplate />
              </div>
            </div>
          </Card>
        )}
      </AntdModal>
    </div>
  );
};

export default ViewActivityReport;
